var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2741_12427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 25.8333C30 28.135 28.135 30 25.8333 30H4.16667C1.86583 30 0 28.135 0 25.8333V4.16667C0 1.865 1.86583 0 4.16667 0H25.8333C28.135 0 30 1.865 30 4.16667V25.8333Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9475 10.0342C24.9858 9.90842 25.0042 9.79175 24.9992 9.68758C24.9867 9.38591 24.7792 9.16675 24.2908 9.16675H22.1092C21.5583 9.16675 21.3042 9.50008 21.1558 9.83425C21.1558 9.83425 19.7958 12.6334 18.2283 14.4792C17.72 15.0134 17.4617 15.0001 17.1867 15.0001C17.0392 15.0001 16.6667 14.8217 16.6667 14.3326V10.0117C16.6667 9.43341 16.5225 9.16675 16.0567 9.16675H12.1825C11.8433 9.16675 11.6667 9.43342 11.6667 9.70092C11.6667 10.2567 12.415 10.3901 12.5 11.9476V14.9667C12.5 15.7001 12.3725 15.8334 12.0975 15.8334C11.3558 15.8334 9.89583 13.3334 8.91833 10.0567C8.70667 9.41175 8.495 9.16675 7.94417 9.16675H5.74167C5.10583 9.16675 5 9.47841 5 9.81175C5 10.4126 5.5 13.6609 8.22917 17.3959C10.2083 20.1042 12.8158 21.6667 15.1242 21.6667C16.5225 21.6667 16.6658 21.3109 16.6658 20.7551V18.2784C16.6667 17.6109 16.8192 17.5001 17.2642 17.5001C17.5817 17.5001 18.2292 17.7084 19.4792 19.1667C20.9208 20.8484 21.1825 21.6667 22.0092 21.6667H24.1908C24.6975 21.6667 24.9883 21.4542 25 21.0417C25.0025 20.9367 24.9875 20.8192 24.9533 20.6884C24.7917 20.2084 24.05 19.0351 23.125 17.9167C22.6125 17.2976 22.1067 16.6842 21.8742 16.3509C21.7183 16.1334 21.6592 15.9801 21.6667 15.8334C21.6742 15.6792 21.7542 15.5326 21.8742 15.3276C21.8525 15.3276 24.6725 11.3684 24.9475 10.0342Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2741_12427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.b926d66b960931b380df34ef4992406c.svg";
export { ForwardRef as ReactComponent };